export class EpochFacade {
    constructor(sdk) { this.sdk = sdk; }
    async epochsInfo(query = {}) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getEpochsInfo(query);
    }
    async epochsInfoWithProof(query = {}) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getEpochsInfoWithProofInfo(query);
    }
    async finalizedInfos(query) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getFinalizedEpochInfos(query);
    }
    async finalizedInfosWithProof(query) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getFinalizedEpochInfosWithProofInfo(query);
    }
    async current() { const w = await this.sdk.getWasmSdkConnected(); return w.getCurrentEpoch(); }
    async currentWithProof() {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getCurrentEpochWithProofInfo();
    }
    async evonodesProposedBlocksByIds(epoch, ids) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getEvonodesProposedEpochBlocksByIds(epoch, ids);
    }
    async evonodesProposedBlocksByIdsWithProof(epoch, ids) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getEvonodesProposedEpochBlocksByIdsWithProofInfo(epoch, ids);
    }
    async evonodesProposedBlocksByRange(query) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getEvonodesProposedEpochBlocksByRange(query);
    }
    async evonodesProposedBlocksByRangeWithProof(query) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getEvonodesProposedEpochBlocksByRangeWithProofInfo(query);
    }
}
